
Ajax = {

    call: function(url, params, options) {

        var jqxhr = $.ajax({

            //crossDomain: true, // if true then HTTP_X_REQUESTED_WITH is false
            type: options.type || 'post',
            url: url,
            dataType: options.dataType || 'html',
            data: params,


            beforeSend: function(){

                if(isFunction(options.onBeforeSend)) {
                    options.onBeforeSend();
                }

                //btns.lockBtn();

            },

            success: function(data, textStatus, jqXHR){

                //btns.unlockBtn();

                if(isFunction(options.onDone)) {
                    options.onDone(data);
                }
            },

            error: function(jqXHR, textStatus, errorThrown){

                //btns.unlockBtn();

                if(isFunction(options.onFail)) {
                    options.onFail(jqXHR, textStatus, errorThrown);
                }
            }

        });

    }



}
